import Vue from 'vue'
import crypto from 'crypto'
import httpManager from '../../util/common'

Vue.config.productionTip = false

let vm = {
  name: 'ApplyUser',
  data: () => {
    return {
      showApplySuccessResult: true,
      showApplyResult: false,
      apply_result: null,
      mailErrMsg: null,
      mailErrMsgShow: false,
      company_name: null,
      lastName: null,
      firstName: null,
      phone: null,
      mail: null,
      other_concern: null,
      concern: [],
      agent: "gzjrfz"
    }
  },
  methods: {
    turnToLogin () {
      this.$router.push("/gzjrfzlogin")
    },

    changeLocale () {
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'en'
        this.$store.dispatch('setLocale', 'en')
        this.another_locale = '中文'
      } else {
        this.$i18n.locale = 'zh'
        this.$store.dispatch('setLocale', 'zh')
        this.another_locale = 'En'
      }
    },
    applyInputOnFocus () {
      this.mailErrMsgShow = false
    },
    apply_on_submit (e) {
      let self = this
      if (!self.mail) {
        self.mailErrMsg = self.$t('login.emailRequired')
        self.mailErrMsgShow = true
        return
      }
      let regEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (self.mail && !regEmail.test(self.mail)) {
        self.mailErrMsg = self.$t('login.invalidEmail')
        self.mailErrMsgShow = true
        return
      }
      let concern = self.concern
      if (self.other_concern) {
        concern.push(self.other_concern)
      }
      let body = {'mail': self.mail,
        'company_name': self.company_name,
        'last_name': self.lastName,
        'first_name': self.firstName,
        'phone': self.phone,
        'concern': concern,
        'agent': self.agent}
      httpManager('apply_access_request', null, body)
        .then(response => {
          if (response.data.mag === 'Error') {
            this.showApplySuccessResult = false
          } else {
            this.showApplySuccessResult = true
          }
          this.showApplyResult = true
        })
        .catch(error => {
          console.log(error)
          this.showApplyResult = true
          this.showApplySuccessResult = false
        })
    },
    getLocaleValue () {
      if (window.location.search.substring(1)) {
        let lang = window.location.search.substring(1).split('=')[1]
        if (lang === 'zh') {
          this.$i18n.locale = 'en'
        } else {
          this.$i18n.locale = 'zh'
        }
        this.changeLocale()
      }
    }
  },
  mounted () {
    this.getLocaleValue()
  }
}
export default vm



// WEBPACK FOOTER //
// ./src/home/js/gzjrfz_apply_user.js